var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTeamMemberMail = function SvgTeamMemberMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M1.1 0C.95 0 .82.03.7.08l6.36 5.7c.28.25.59.25.87 0L14.3.08a1.05 1.05 0 0 0-.4-.08H1.1ZM0 .99v7.86C0 9.49.49 10 1.1 10h12.8c.61 0 1.1-.51 1.1-1.15v-7.7L14.99 1 8.64 6.66c-.65.59-1.64.59-2.3 0L.02.99Z"
  })));
};
export default SvgTeamMemberMail;